module.exports = __webpack_public_path__ + "img/core-bottom.5fde0999.png";